import { EntityVm } from 'api/core/entity.vm';
import { IsString, IsDate, IsOptional, IsEnum } from 'class-validator';

export enum SerialNumberStatus {
  UNINITIALIZED = 'UNINITIALIZED',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export class SerialNumberVm extends EntityVm {
  @IsString()
  productId: string;

  @IsString()
  barcode: string;

  @IsDate()
  @IsOptional()
  expiration: Date;

  @IsEnum(SerialNumberStatus)
  status: SerialNumberStatus;
}
